/* global Promise */

define('v3/Common/Helpers/SignedCookies/requestSignedCookies',[], function () {
	return {
		requestSignedCookies:
			function requestSignedCookies (accessToken, environment) {
				if (!environment) {
					environment = 'master';
				}
				var lastCheckKeyName = 'signed-cookies-check';
				var checkDelayHours = 3;
				var signedCookiesServiceUrl = environment === 'master'
					? 'https://signed-cookies.content-master.metro.snappet.org/'
					: 'https://signed-cookies.content.metro.snappet.org/';
				var now = new Date().getTime();
				var lastCheck = parseInt(localStorage.getItem(lastCheckKeyName), 10) || 0;
				var hoursSinceLastCheck = Math.abs(lastCheck - now) / 36e5;
				if (hoursSinceLastCheck < checkDelayHours) {
					return Promise.resolve();
				}
				return new Promise(function (resolve, reject) {
					fetch(signedCookiesServiceUrl,
						{
							method: 'GET',
							mode: 'cors',
							cache: 'no-cache',
							credentials: 'include',
							headers: {
								'x-content-authorization': 'Bearer ' + accessToken
							}
						})
						.then(function (response) {
							if (response.status === 200) {
								localStorage.setItem(lastCheckKeyName, now.toString());
								resolve(response);
							} else {
								reject(response);
							}
						})
						.catch(function (e) {
							reject(e);
						});
				});
			}
	};
});

